import React, { Component } from 'react';
import Select from 'react-select';

import services from './data';

let CategoryOptions = [];

class OMCList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      selectedOption: null,
    };
  }

  componentDidMount() {
    services
      .getOMCList()
      .then((response) => {
        const tmp = response.data.data;
        CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].uuid,
            label: tmp[i].omc,
          });
        }
        this.setState({
          options: CategoryOptions,
          selectedOption: CategoryOptions[0],
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleChange = (selectedOption) => {
    this.props.handleOMCChange(selectedOption.value);
    this.setState({ selectedOption });
  };

  render() {
    const { options, selectedOption } = this.state;
    return (
      <Select
        onChange={this.handleChange}
        options={options}
        className="select-box-container"
        classNamePrefix="raw-select"
        name="oml"
        placeholder="Select OMC"
        value={selectedOption}
        isDisabled={this.props.disabled || false}
      />
    );
  }
}

export { CategoryOptions, OMCList };
